import React, { useCallback, useEffect, useState } from 'react';
import { api, copiar, criadoTenant, dataBR, dataHoraBR, diasAte, emailTenant, gerarSenha, inteiro, moeda, MODULOS, nomeTenant, PERFIS, SITUACAO, telefoneTenant, UFS } from '../api';
import { Campo, Carregando, Chip, Modal, useToast } from '../components/Base';
import { Barras } from '../components/Graficos';
import { ACOES } from './Painel';

function paramDaRota(nome) {
  const q = (window.location.hash.split('?')[1] || '');
  return new URLSearchParams(q).get(nome) || '';
}

export default function Empresas({ idAberto }) {
  const [lista, setLista] = useState(null);
  const [status, setStatus] = useState(paramDaRota('status'));
  const [plano, setPlano] = useState('');
  const [busca, setBusca] = useState('');
  const [planos, setPlanos] = useState([]);
  const avisar = useToast();

  const carregar = useCallback(() => {
    const q = new URLSearchParams();
    if (status) q.set('status', status);
    if (plano) q.set('plano', plano);
    if (busca) q.set('busca', busca);
    api('/tenants?' + q.toString()).then(setLista).catch(e => avisar(e.message, 'erro'));
  }, [status, plano, busca, avisar]);

  useEffect(() => { const t = setTimeout(carregar, 250); return () => clearTimeout(t); }, [carregar]);
  useEffect(() => { api('/planos').then(setPlanos).catch(() => {}); }, []);

  const abrir = id => { window.location.hash = '#/empresas/' + id; };
  const fechar = useCallback(() => { window.location.hash = '#/empresas'; carregar(); }, [carregar]);

  return (
    <>
      <div className="cartao" style={{ marginBottom: 14 }}>
        <div className="linha">
          <input placeholder="Buscar por nome, e-mail, CNPJ, cidade, telefone…" value={busca} onChange={e => setBusca(e.target.value)}
            style={{ flex: 1, minWidth: 220, border: '1px solid var(--borda)', borderRadius: 6, padding: '8px 10px', minHeight: 36 }} />
          <select value={status} onChange={e => setStatus(e.target.value)} style={{ border: '1px solid var(--borda)', borderRadius: 6, padding: '8px 10px', minHeight: 36 }}>
            <option value="">Todas as situações</option>
            {Object.keys(SITUACAO).map(s => <option key={s} value={s}>{SITUACAO[s]}</option>)}
          </select>
          <select value={plano} onChange={e => setPlano(e.target.value)} style={{ border: '1px solid var(--borda)', borderRadius: 6, padding: '8px 10px', minHeight: 36 }}>
            <option value="">Todos os planos</option>
            {planos.map(p => <option key={p.codigo} value={p.codigo}>{p.nome}</option>)}
          </select>
          <span className="mudo pequeno">{lista ? `${lista.length} empresa(s)` : ''}</span>
          <span className="espaco" />
          <a className="btn" href="#/empresas/nova">+ Nova empresa</a>
        </div>
      </div>

      {!lista ? <Carregando /> : lista.length === 0 ? (
        <div className="cartao vazio">
          Nenhuma empresa encontrada.
          {!busca && !status && !plano && <div style={{ marginTop: 10 }}><a className="btn" href="#/empresas/nova">Cadastrar a primeira empresa</a></div>}
        </div>
      ) : (
        <div className="cartao tabela-wrap mob-cards" style={{ padding: 0 }}>
          <table>
            <thead>
              <tr>
                <th>Empresa</th><th>Situação</th><th>Plano</th><th>Teste até</th>
                <th className="num">Usuários</th><th className="num">Cabines</th><th className="num">Locações</th><th>Último acesso</th>
              </tr>
            </thead>
            <tbody>
              {lista.map(t => {
                const dias = diasAte(t.trial_fim_fmt);
                return (
                  <tr key={t.id} className="clicavel" onClick={() => abrir(t.id)}>
                    <td data-label="Empresa"><div>{nomeTenant(t)}</div><div className="mudo pequeno">{emailTenant(t)}{t.cidade ? ` · ${t.cidade}${t.uf ? '/' + t.uf : ''}` : ''}</div></td>
                    <td data-label="Situação"><Chip status={t.status}>{SITUACAO[t.status] || t.status}</Chip></td>
                    <td data-label="Plano">{t.plano_nome || t.plano || '—'}<div className="mudo pequeno">{moeda(t.valor_mensal ?? t.plano_valor)}/mês</div></td>
                    <td data-label="Teste até">{t.status === 'trial' ? <>{dataBR(t.trial_fim_fmt)} <span className={'pequeno ' + (dias !== null && dias <= 3 ? '' : 'mudo')} style={dias !== null && dias < 0 ? { color: 'var(--erro)' } : undefined}>{dias === null ? '' : dias < 0 ? `(venceu)` : `(${dias} d)`}</span></> : '—'}</td>
                    <td className="num" data-label="Usuários">{t.qtd_usuarios}</td>
                    <td className="num" data-label="Cabines">{t.qtd_unidades}</td>
                    <td className="num" data-label="Locações">{t.qtd_locacoes}</td>
                    <td data-label="Último acesso">{t.ultimo_acesso ? dataHoraBR(t.ultimo_acesso) : <span className="mudo">nunca</span>}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {idAberto === 'nova' && <NovaEmpresa planos={planos} onFechar={fechar} onCriada={id => { window.location.hash = '#/empresas/' + id; carregar(); }} />}
      {idAberto && idAberto !== 'nova' && <DetalheEmpresa id={idAberto} planos={planos} onFechar={fechar} />}
    </>
  );
}

// ---------------- nova empresa ----------------
function NovaEmpresa({ planos, onFechar, onCriada }) {
  const [f, setF] = useState({
    nome: '', razao_social: '', cnpj: '', email: '', telefone: '', whatsapp: '', cidade: '', uf: 'SP',
    plano: '', valor_mensal: '', status: 'trial', trial_dias: 14, modulos: ['banheiros', 'fossa'], obs_admin: '',
    usuario: { nome: '', email: '', senha: gerarSenha() },
  });
  const [salvando, setSalvando] = useState(false);
  const [criada, setCriada] = useState(null);
  const avisar = useToast();
  useEffect(() => { if (!f.plano && planos.length) setF(x => ({ ...x, plano: (planos.find(p => p.ativo) || planos[0]).codigo })); }, [planos, f.plano]);

  const set = (k, v) => setF(x => ({ ...x, [k]: v }));
  const setU = (k, v) => setF(x => ({ ...x, usuario: { ...x.usuario, [k]: v } }));
  const p = planos.find(x => x.codigo === f.plano);

  async function salvar() {
    if (!f.nome.trim()) return avisar('Informe o nome da empresa', 'erro');
    if (!f.usuario.nome.trim() || !f.usuario.email.trim() || f.usuario.senha.length < 6) return avisar('Preencha o usuário administrador (nome, e-mail e senha com 6+)', 'erro');
    if (!f.modulos.length) return avisar('Escolha pelo menos um módulo', 'erro');
    setSalvando(true);
    try {
      const r = await api('/tenants', { method: 'POST', body: { ...f, email: f.email || f.usuario.email } });
      setCriada({ id: r.id, ...f });
    } catch (e) { avisar(e.message, 'erro'); } finally { setSalvando(false); }
  }

  if (criada) {
    const texto = `Olá, ${criada.usuario.nome}! Seu acesso ao Controla Banheiros está pronto.\n\nEndereço: https://app.controlabanheiros.com.br\nE-mail: ${criada.usuario.email}\nSenha: ${criada.usuario.senha}\n\nRecomendamos trocar a senha no primeiro acesso.`;
    return (
      <Modal titulo="Empresa criada" subtitulo={criada.nome} largura={520} onFechar={() => onCriada(criada.id)}
        rodape={<><button className="btn secundario" onClick={async () => { (await copiar(texto)) ? avisar('Copiado') : avisar('Não consegui copiar', 'erro'); }}>Copiar mensagem</button>
          <a className="btn secundario" target="_blank" rel="noreferrer" href={`https://wa.me/55${String(criada.whatsapp || criada.telefone || '').replace(/\D/g, '')}?text=${encodeURIComponent(texto)}`}>Enviar no WhatsApp</a>
          <button className="btn" onClick={() => onCriada(criada.id)}>Abrir empresa</button></>}>
        <div className="aviso" style={{ marginBottom: 12 }}>Anote a senha agora — ela não fica visível depois (só é possível redefinir).</div>
        <dl className="lista-def">
          <dt>Sistema</dt><dd>https://app.controlabanheiros.com.br</dd>
          <dt>E-mail</dt><dd>{criada.usuario.email}</dd>
          <dt>Senha</dt><dd><code style={{ fontSize: 15 }}>{criada.usuario.senha}</code></dd>
          <dt>Situação</dt><dd>{criada.status === 'trial' ? `Teste grátis por ${criada.trial_dias} dias` : 'Assinatura ativa'} · plano {p ? p.nome : criada.plano}</dd>
        </dl>
      </Modal>
    );
  }

  return (
    <Modal titulo="Nova empresa" subtitulo="Cria a empresa, o usuário administrador e os dados iniciais (tipos de cabine, catálogo, plano de contas)" onFechar={onFechar}
      rodape={<><button className="btn secundario" onClick={onFechar}>Cancelar</button><button className="btn" onClick={salvar} disabled={salvando}>{salvando ? 'Criando…' : 'Criar empresa'}</button></>}>
      <h2 className="sub">Empresa</h2>
      <div className="grid grid-2">
        <Campo label="Nome fantasia *"><input value={f.nome} onChange={e => set('nome', e.target.value)} autoFocus placeholder="Ex.: Sanitários Osasco" /></Campo>
        <Campo label="Razão social"><input value={f.razao_social} onChange={e => set('razao_social', e.target.value)} /></Campo>
        <Campo label="CNPJ"><input value={f.cnpj} onChange={e => set('cnpj', e.target.value)} placeholder="00.000.000/0001-00" /></Campo>
        <Campo label="E-mail da empresa (vazio = o do administrador)"><input type="email" value={f.email} onChange={e => set('email', e.target.value)} /></Campo>
        <Campo label="Telefone"><input value={f.telefone} onChange={e => set('telefone', e.target.value)} placeholder="(11) 99999-9999" /></Campo>
        <Campo label="WhatsApp"><input value={f.whatsapp} onChange={e => set('whatsapp', e.target.value)} placeholder="(11) 99999-9999" /></Campo>
        <Campo label="Cidade"><input value={f.cidade} onChange={e => set('cidade', e.target.value)} /></Campo>
        <Campo label="UF"><select value={f.uf} onChange={e => set('uf', e.target.value)}>{UFS.map(u => <option key={u}>{u}</option>)}</select></Campo>
      </div>
      <Campo label="Módulos">
        <div className="linha" style={{ minHeight: 36 }}>
          {Object.keys(MODULOS).map(m => (
            <label key={m} className="check"><input type="checkbox" checked={f.modulos.includes(m)} onChange={e => set('modulos', e.target.checked ? [...f.modulos, m] : f.modulos.filter(x => x !== m))} /> {MODULOS[m]}</label>
          ))}
        </div>
      </Campo>

      <h2 className="sub">Assinatura</h2>
      <div className="grid grid-2">
        <Campo label="Plano">
          <select value={f.plano} onChange={e => set('plano', e.target.value)}>
            {planos.filter(x => x.ativo).map(x => <option key={x.codigo} value={x.codigo}>{x.nome} — {moeda(x.valor)}/mês</option>)}
          </select>
        </Campo>
        <Campo label={`Valor negociado (vazio = ${p ? moeda(p.valor) : 'valor do plano'})`}><input type="number" step="0.01" min="0" inputMode="decimal" value={f.valor_mensal} onChange={e => set('valor_mensal', e.target.value)} /></Campo>
        <Campo label="Situação inicial">
          <select value={f.status} onChange={e => set('status', e.target.value)}>
            <option value="trial">Teste grátis</option>
            <option value="ativo">Ativa (já pagando)</option>
          </select>
        </Campo>
        {f.status === 'trial' && <Campo label="Dias de teste"><input type="number" min="1" max="365" value={f.trial_dias} onChange={e => set('trial_dias', e.target.value)} /></Campo>}
      </div>

      <h2 className="sub">Usuário administrador</h2>
      <div className="grid grid-2">
        <Campo label="Nome *"><input value={f.usuario.nome} onChange={e => setU('nome', e.target.value)} /></Campo>
        <Campo label="E-mail (login) *"><input type="email" value={f.usuario.email} onChange={e => setU('email', e.target.value)} /></Campo>
        <Campo label="Senha inicial *">
          <div className="linha" style={{ flexWrap: 'nowrap' }}>
            <input type="text" value={f.usuario.senha} onChange={e => setU('senha', e.target.value)} />
            <button type="button" className="btn secundario pequeno" onClick={() => setU('senha', gerarSenha())}>Gerar</button>
          </div>
        </Campo>
      </div>
      <Campo label="Observações internas (só o painel vê)"><textarea rows="2" value={f.obs_admin} onChange={e => set('obs_admin', e.target.value)} placeholder="Como chegou, quem indicou, combinados…" /></Campo>
    </Modal>
  );
}

// ---------------- detalhe ----------------
function DetalheEmpresa({ id, planos, onFechar }) {
  const [d, setD] = useState(null);
  const [aba, setAba] = useState('dados');
  const [acao, setAcao] = useState(null); // { tipo, usuario? }
  const avisar = useToast();

  const carregar = useCallback(() => api('/tenants/' + id).then(setD).catch(e => { avisar(e.message, 'erro'); onFechar(); }), [id, avisar, onFechar]);
  useEffect(() => { carregar(); }, [carregar]);

  async function mudarStatus(novo, motivo) {
    try {
      await api(`/tenants/${id}/status`, { method: 'PUT', body: { status: novo, motivo } });
      avisar('Situação alterada para ' + SITUACAO[novo]);
      setAcao(null); carregar();
    } catch (e) { avisar(e.message, 'erro'); }
  }

  async function acessar(usuarioId) {
    try {
      const r = await api(`/tenants/${id}/acesso`, { method: 'POST', body: { usuario_id: usuarioId } });
      window.open(r.url, '_blank', 'noopener');
      avisar('Abrindo o sistema como ' + r.usuario);
    } catch (e) { avisar(e.message, 'erro'); }
  }

  if (!d) return <Modal titulo="Empresa" onFechar={onFechar}><Carregando /></Modal>;
  const t = d.tenant;
  const dias = diasAte(t.trial_fim_fmt);
  const podeAcessar = t.status === 'ativo' || t.status === 'trial';

  const rodape = (
    <>
      {podeAcessar && <button className="btn secundario" onClick={() => acessar()} title="Abre o sistema logado como o administrador da empresa">Acessar como empresa</button>}
      <span className="espaco" />
      {t.status !== 'ativo' && <button className="btn ok" onClick={() => mudarStatus('ativo')}>Ativar assinatura</button>}
      {t.status === 'trial' && <button className="btn secundario" onClick={() => setAcao({ tipo: 'trial' })}>Estender teste</button>}
      {t.status === 'suspenso' && <button className="btn secundario" onClick={() => setAcao({ tipo: 'trial' })}>Voltar ao teste</button>}
      <button className="btn secundario" onClick={() => setAcao({ tipo: 'plano' })}>Trocar plano</button>
      {podeAcessar && <button className="btn perigo" onClick={() => setAcao({ tipo: 'suspender' })}>Suspender</button>}
      {t.status !== 'cancelado' && <button className="btn perigo" onClick={() => setAcao({ tipo: 'cancelar' })}>Cancelar</button>}
    </>
  );

  return (
    <Modal titulo={nomeTenant(t)} subtitulo={`#${t.id} · ${emailTenant(t)}${telefoneTenant(t) ? ' · ' + telefoneTenant(t) : ''}`} onFechar={onFechar} rodape={rodape} largura={860}>
      <div className="linha" style={{ marginBottom: 12 }}>
        <Chip status={t.status}>{SITUACAO[t.status] || t.status}</Chip>
        <Chip>{t.plano_nome || t.plano || 'sem plano'} · {moeda(t.valor_mensal ?? t.plano_valor)}/mês</Chip>
        {t.status === 'trial' && <Chip status={dias !== null && dias < 0 ? 'suspenso' : 'trial'}>teste até {dataBR(t.trial_fim_fmt)}{dias !== null ? ` (${dias < 0 ? 'venceu' : dias + ' d'})` : ''}</Chip>}
        {(t.modulos || []).map(m => <Chip key={m}>{MODULOS[m] || m}</Chip>)}
        {t.suspenso_em && (t.status === 'suspenso' || t.status === 'cancelado') && <span className="mudo pequeno">desde {dataHoraBR(t.suspenso_em)}</span>}
      </div>

      <div className="abas">
        {[['dados', 'Dados'], ['uso', 'Uso'], ['usuarios', `Usuários (${d.usuarios.length})`], ['obs', 'Observações / Asaas'], ['historico', 'Histórico']].map(([k, n]) => (
          <button key={k} className={aba === k ? 'ativa' : ''} onClick={() => setAba(k)}>{n}</button>
        ))}
      </div>

      {aba === 'dados' && <FormDados t={t} onSalvo={() => { avisar('Dados salvos'); carregar(); }} />}

      {aba === 'uso' && (
        <>
          <div className="grid grid-4">
            {[['usuarios', 'Usuários'], ['clientes', 'Clientes'], ['unidades', 'Cabines'], ['locacoes', 'Locações'], ['servicos', 'Ordens de serviço'], ['orcamentos', 'Orçamentos'], ['faturas', 'Faturas'], ['veiculos', 'Veículos']].map(([k, n]) => (
              <div key={k} className="mini"><div className="mudo pequeno">{n}</div><strong>{d.contagens[k] ?? '—'}</strong></div>
            ))}
          </div>
          <dl className="lista-def" style={{ marginTop: 14 }}>
            <dt>Cadastro</dt><dd>{dataHoraBR(criadoTenant(t))}</dd>
            <dt>Último acesso</dt><dd>{t.ultimo_acesso ? dataHoraBR(t.ultimo_acesso) : 'nunca'}</dd>
          </dl>
          <div className="grid grid-2 secao">
            <div><h2 className="sub">Locações criadas (6 meses)</h2><Barras dados={d.atividade || []} series={[{ chave: 'locacoes', nome: 'Locações' }]} formato={inteiro} altura={170} /></div>
            <div><h2 className="sub">Faturas da empresa (6 meses)</h2><Barras dados={d.atividade || []} series={[{ chave: 'emitido', nome: 'Emitido' }, { chave: 'recebido', nome: 'Recebido' }]} formato={moeda} formatoEixo={v => 'R$ ' + Math.round(v / 1000) + 'k'} altura={170} /></div>
          </div>
        </>
      )}

      {aba === 'usuarios' && (
        <>
          <div className="linha" style={{ marginBottom: 10 }}>
            <span className="espaco" />
            <button className="btn pequeno" onClick={() => setAcao({ tipo: 'novo_usuario' })}>+ Novo usuário</button>
          </div>
          <div className="tabela-wrap">
            <table>
              <thead><tr><th>Nome</th><th>E-mail</th><th>Perfil</th><th>Último login</th><th></th></tr></thead>
              <tbody>
                {d.usuarios.map(u => (
                  <tr key={u.id} style={u.ativo === 0 ? { opacity: .55 } : undefined}>
                    <td>{u.nome || '—'}{u.ativo === 0 && <span className="mudo pequeno"> (inativo)</span>}</td><td>{u.email}</td><td>{PERFIS[u.role] || u.role || '—'}</td>
                    <td className="mudo pequeno">{u.ultimo_login ? dataHoraBR(u.ultimo_login) : 'nunca'}</td>
                    <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                      {podeAcessar && u.ativo !== 0 && u.role !== 'motorista' && <button className="btn secundario pequeno" onClick={() => acessar(u.id)}>Acessar</button>}{' '}
                      <button className="btn secundario pequeno" onClick={() => setAcao({ tipo: 'editar_usuario', usuario: u })}>Editar</button>{' '}
                      <button className="btn secundario pequeno" onClick={() => setAcao({ tipo: 'senha', usuario: u })}>Nova senha</button>
                    </td>
                  </tr>
                ))}
                {d.usuarios.length === 0 && <tr><td colSpan="5" className="vazio">Nenhum usuário.</td></tr>}
              </tbody>
            </table>
          </div>
        </>
      )}

      {aba === 'obs' && <FormObs t={t} onSalvo={() => { avisar('Salvo'); carregar(); }} />}

      {aba === 'historico' && (
        <div>
          {d.logs.length === 0 && <div className="vazio">Nenhuma ação registrada.</div>}
          {d.logs.map(l => (
            <div key={l.id} style={{ padding: '8px 0', borderBottom: '1px solid var(--borda)' }}>
              <strong>{ACOES[l.acao] || l.acao}</strong> <span className="mudo pequeno">— {dataHoraBR(l.criado_em)} · {l.admin_email || 'automático'}</span>
              <div className="pequeno">{l.detalhe}</div>
            </div>
          ))}
        </div>
      )}

      {acao && acao.tipo === 'plano' && <FormPlano t={t} planos={planos} onFechar={() => setAcao(null)} onSalvo={() => { setAcao(null); avisar('Plano alterado'); carregar(); }} />}
      {acao && acao.tipo === 'trial' && <FormTrial t={t} onFechar={() => setAcao(null)} onSalvo={() => { setAcao(null); avisar('Teste atualizado'); carregar(); }} />}
      {acao && acao.tipo === 'senha' && <FormSenha t={t} usuario={acao.usuario} onFechar={() => setAcao(null)} onSalvo={() => { setAcao(null); avisar('Senha redefinida'); }} />}
      {acao && acao.tipo === 'novo_usuario' && <FormUsuario t={t} onFechar={() => setAcao(null)} onSalvo={() => { setAcao(null); avisar('Usuário criado'); carregar(); }} />}
      {acao && acao.tipo === 'editar_usuario' && <FormUsuario t={t} usuario={acao.usuario} onFechar={() => setAcao(null)} onSalvo={() => { setAcao(null); avisar('Usuário salvo'); carregar(); }} />}
      {acao && (acao.tipo === 'suspender' || acao.tipo === 'cancelar') && (
        <FormMotivo
          titulo={acao.tipo === 'suspender' ? 'Suspender acesso' : 'Cancelar assinatura'}
          texto={acao.tipo === 'suspender'
            ? 'A empresa não vai conseguir entrar no sistema até ser reativada. Os dados continuam guardados.'
            : 'Cancelado é definitivo para o cliente (ele pode ser reativado por aqui, mas trate como encerrado).'}
          onFechar={() => setAcao(null)}
          onConfirmar={motivo => mudarStatus(acao.tipo === 'suspender' ? 'suspenso' : 'cancelado', motivo)}
        />
      )}
    </Modal>
  );
}

function FormDados({ t, onSalvo }) {
  const [f, setF] = useState({
    nome: t.nome || '', razao_social: t.razao_social || '', cnpj: t.cnpj || '', email: t.email || '', telefone: t.telefone || '',
    whatsapp: t.whatsapp || '', cidade: t.cidade || '', uf: t.uf || '', modulos: t.modulos && t.modulos.length ? t.modulos : ['banheiros', 'fossa'],
  });
  const [salvando, setSalvando] = useState(false);
  const avisar = useToast();
  const set = (k, v) => setF(x => ({ ...x, [k]: v }));
  async function salvar() {
    setSalvando(true);
    try { await api(`/tenants/${t.id}/dados`, { method: 'PUT', body: f }); onSalvo(); }
    catch (e) { avisar(e.message, 'erro'); } finally { setSalvando(false); }
  }
  return (
    <>
      <div className="grid grid-2">
        <Campo label="Nome fantasia *"><input value={f.nome} onChange={e => set('nome', e.target.value)} /></Campo>
        <Campo label="Razão social"><input value={f.razao_social} onChange={e => set('razao_social', e.target.value)} /></Campo>
        <Campo label="CNPJ"><input value={f.cnpj} onChange={e => set('cnpj', e.target.value)} /></Campo>
        <Campo label="E-mail"><input type="email" value={f.email} onChange={e => set('email', e.target.value)} /></Campo>
        <Campo label="Telefone"><input value={f.telefone} onChange={e => set('telefone', e.target.value)} /></Campo>
        <Campo label="WhatsApp"><input value={f.whatsapp} onChange={e => set('whatsapp', e.target.value)} /></Campo>
        <Campo label="Cidade"><input value={f.cidade} onChange={e => set('cidade', e.target.value)} /></Campo>
        <Campo label="UF"><select value={f.uf} onChange={e => set('uf', e.target.value)}><option value="">—</option>{UFS.map(u => <option key={u}>{u}</option>)}</select></Campo>
      </div>
      <Campo label="Módulos">
        <div className="linha" style={{ minHeight: 36 }}>
          {Object.keys(MODULOS).map(m => (
            <label key={m} className="check"><input type="checkbox" checked={f.modulos.includes(m)} onChange={e => set('modulos', e.target.checked ? [...f.modulos, m] : f.modulos.filter(x => x !== m))} /> {MODULOS[m]}</label>
          ))}
        </div>
      </Campo>
      <div className="linha"><span className="espaco" /><button className="btn" onClick={salvar} disabled={salvando}>Salvar dados</button></div>
    </>
  );
}

function FormUsuario({ t, usuario, onFechar, onSalvo }) {
  const novo = !usuario;
  const [f, setF] = useState({ nome: usuario ? usuario.nome || '' : '', email: usuario ? usuario.email : '', telefone: usuario ? usuario.telefone || '' : '', role: usuario ? usuario.role || 'operador' : 'operador', ativo: usuario ? usuario.ativo !== 0 : true, senha: gerarSenha() });
  const [salvando, setSalvando] = useState(false);
  const avisar = useToast();
  const set = (k, v) => setF(x => ({ ...x, [k]: v }));
  async function salvar() {
    setSalvando(true);
    try {
      if (novo) await api(`/tenants/${t.id}/usuarios`, { method: 'POST', body: f });
      else await api(`/tenants/${t.id}/usuarios/${usuario.id}`, { method: 'PUT', body: { nome: f.nome, telefone: f.telefone, role: f.role, ativo: f.ativo } });
      onSalvo();
    } catch (e) { avisar(e.message, 'erro'); } finally { setSalvando(false); }
  }
  return (
    <Modal titulo={novo ? 'Novo usuário' : 'Editar usuário'} subtitulo={novo ? nomeTenant(t) : usuario.email} largura={480} onFechar={onFechar}
      rodape={<><button className="btn secundario" onClick={onFechar}>Voltar</button><button className="btn" onClick={salvar} disabled={salvando}>{novo ? 'Criar' : 'Salvar'}</button></>}>
      <Campo label="Nome *"><input value={f.nome} onChange={e => set('nome', e.target.value)} autoFocus /></Campo>
      {novo && <Campo label="E-mail (login) *"><input type="email" value={f.email} onChange={e => set('email', e.target.value)} /></Campo>}
      <div className="grid grid-2">
        <Campo label="Perfil"><select value={f.role} onChange={e => set('role', e.target.value)}>{Object.keys(PERFIS).map(r => <option key={r} value={r}>{PERFIS[r]}</option>)}</select></Campo>
        <Campo label="Telefone"><input value={f.telefone} onChange={e => set('telefone', e.target.value)} /></Campo>
      </div>
      {novo
        ? <Campo label="Senha inicial *"><div className="linha" style={{ flexWrap: 'nowrap' }}><input type="text" value={f.senha} onChange={e => set('senha', e.target.value)} /><button type="button" className="btn secundario pequeno" onClick={() => set('senha', gerarSenha())}>Gerar</button></div></Campo>
        : <label className="check" style={{ display: 'block', marginBottom: 12 }}><input type="checkbox" checked={f.ativo} onChange={e => set('ativo', e.target.checked)} /> Usuário ativo (desmarque para bloquear o acesso)</label>}
      {novo && <div className="mudo pequeno">Passe a senha para a pessoa e peça para trocar ao entrar.</div>}
    </Modal>
  );
}

function FormPlano({ t, planos, onFechar, onSalvo }) {
  const [plano, setPlano] = useState(t.plano || (planos[0] && planos[0].codigo) || '');
  const [valor, setValor] = useState(t.valor_mensal ?? '');
  const [salvando, setSalvando] = useState(false);
  const avisar = useToast();
  const p = planos.find(x => x.codigo === plano);
  async function salvar() {
    setSalvando(true);
    try { await api(`/tenants/${t.id}/plano`, { method: 'PUT', body: { plano, valor_mensal: valor } }); onSalvo(); }
    catch (e) { avisar(e.message, 'erro'); } finally { setSalvando(false); }
  }
  return (
    <Modal titulo="Trocar plano" largura={440} onFechar={onFechar} rodape={<><button className="btn secundario" onClick={onFechar}>Voltar</button><button className="btn" onClick={salvar} disabled={salvando}>Salvar</button></>}>
      <Campo label="Plano">
        <select value={plano} onChange={e => setPlano(e.target.value)}>
          {planos.filter(x => x.ativo || x.codigo === t.plano).map(x => <option key={x.codigo} value={x.codigo}>{x.nome} — {moeda(x.valor)}/mês</option>)}
        </select>
      </Campo>
      <Campo label={`Valor negociado (deixe vazio para usar o do plano${p ? ': ' + moeda(p.valor) : ''})`}>
        <input type="number" step="0.01" min="0" inputMode="decimal" value={valor} onChange={e => setValor(e.target.value)} placeholder={p ? String(p.valor) : ''} />
      </Campo>
    </Modal>
  );
}

function FormTrial({ t, onFechar, onSalvo }) {
  const [data, setData] = useState(t.trial_fim_fmt || '');
  const [salvando, setSalvando] = useState(false);
  const avisar = useToast();
  async function salvar(body) {
    setSalvando(true);
    try { await api(`/tenants/${t.id}/trial`, { method: 'PUT', body }); onSalvo(); }
    catch (e) { avisar(e.message, 'erro'); } finally { setSalvando(false); }
  }
  return (
    <Modal titulo="Período de teste" largura={440} onFechar={onFechar} rodape={<><button className="btn secundario" onClick={onFechar}>Voltar</button><button className="btn" onClick={() => salvar({ trial_fim: data })} disabled={salvando || !data}>Salvar data</button></>}>
      <div className="linha" style={{ marginBottom: 14 }}>
        <span className="mudo pequeno">Atalhos:</span>
        {[7, 14, 30].map(n => <button key={n} className="btn secundario pequeno" disabled={salvando} onClick={() => salvar({ dias: n })}>+{n} dias</button>)}
      </div>
      <Campo label="Ou escolha a data final"><input type="date" value={data} onChange={e => setData(e.target.value)} /></Campo>
      {t.status === 'suspenso' && <div className="aviso">A empresa volta para "Teste grátis" até a nova data.</div>}
    </Modal>
  );
}

function FormSenha({ t, usuario, onFechar, onSalvo }) {
  const [senha, setSenha] = useState(gerarSenha());
  const [salvando, setSalvando] = useState(false);
  const avisar = useToast();
  async function salvar() {
    setSalvando(true);
    try { await api(`/tenants/${t.id}/usuarios/${usuario.id}/senha`, { method: 'PUT', body: { senha } }); onSalvo(); }
    catch (e) { avisar(e.message, 'erro'); } finally { setSalvando(false); }
  }
  return (
    <Modal titulo="Nova senha" subtitulo={usuario.email} largura={420} onFechar={onFechar} rodape={<><button className="btn secundario" onClick={onFechar}>Voltar</button><button className="btn" onClick={salvar} disabled={salvando || senha.length < 6}>Redefinir</button></>}>
      <Campo label="Senha (mínimo 6 caracteres)"><div className="linha" style={{ flexWrap: 'nowrap' }}><input type="text" value={senha} onChange={e => setSenha(e.target.value)} autoFocus /><button type="button" className="btn secundario pequeno" onClick={() => setSenha(gerarSenha())}>Gerar</button></div></Campo>
      <div className="mudo pequeno">Passe a senha para o cliente e peça para ele trocar ao entrar.</div>
    </Modal>
  );
}

function FormObs({ t, onSalvo }) {
  const [f, setF] = useState({ obs_admin: t.obs_admin || '', asaas_customer_id: t.asaas_customer_id || '', asaas_subscription_id: t.asaas_subscription_id || '' });
  const [salvando, setSalvando] = useState(false);
  const avisar = useToast();
  async function salvar() {
    setSalvando(true);
    try { await api(`/tenants/${t.id}/obs`, { method: 'PUT', body: f }); onSalvo(); }
    catch (e) { avisar(e.message, 'erro'); } finally { setSalvando(false); }
  }
  return (
    <>
      <Campo label="Observações internas"><textarea rows="4" value={f.obs_admin} onChange={e => setF({ ...f, obs_admin: e.target.value })} /></Campo>
      <div className="grid grid-2">
        <Campo label="Asaas — ID do cliente"><input value={f.asaas_customer_id} onChange={e => setF({ ...f, asaas_customer_id: e.target.value })} placeholder="cus_..." /></Campo>
        <Campo label="Asaas — ID da assinatura"><input value={f.asaas_subscription_id} onChange={e => setF({ ...f, asaas_subscription_id: e.target.value })} placeholder="sub_..." /></Campo>
      </div>
      <div className="linha"><span className="espaco" /><button className="btn" onClick={salvar} disabled={salvando}>Salvar</button></div>
    </>
  );
}

function FormMotivo({ titulo, texto, onFechar, onConfirmar }) {
  const [motivo, setMotivo] = useState('');
  return (
    <Modal titulo={titulo} largura={440} onFechar={onFechar} rodape={<><button className="btn secundario" onClick={onFechar}>Voltar</button><button className="btn perigo" onClick={() => onConfirmar(motivo)}>Confirmar</button></>}>
      <div className="aviso" style={{ marginBottom: 12 }}>{texto}</div>
      <Campo label="Motivo (opcional)"><input value={motivo} onChange={e => setMotivo(e.target.value)} placeholder="Ex.: inadimplente desde março" /></Campo>
    </Modal>
  );
}
